import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery,
  tagTypes: ["Dashboard"],
  endpoints: (builder) => ({
    // getDashboard: builder.query({
    //   query: ({ page = 1, pageSize = 20 } = {}) =>
    //     `${apiurl.Export_data}?pageNumber=${page}&pageSize=${pageSize}`,

    //   transformResponse: (response) => {
    //     const {
    //       totalCount = 0,
    //       data: rows = [],
    //       lastWeekPercentage = 0,
    //       lastMonthPercentage = 0,
    //       thisWeekPercentage = 0,
    //       thisMonthPercentage = 0,
    //       weekComparison = "-",
    //       monthComparison = "-",
    //     } = response?.data || {};

    //     return {
    //       rows,
    //       totalCount,
    //       lastWeekPercentage,
    //       lastMonthPercentage,
    //       thisWeekPercentage,
    //       thisMonthPercentage,
    //       weekComparison,
    //       monthComparison,
    //     };
    //   },

    //   providesTags: ["Dashboard"],
    // }),

    getDashboard: builder.query({
      query: ({
        page = 1,
        pageSize = 20,
        financialYear,
        cityId,
        organizationId,
      } = {}) => {
        let url = `${apiurl.Export_data}?pageNumber=${page}&pageSize=${pageSize}`;
    
        // ✅ Add filters if present
        if (financialYear) url += `&financialYear=${financialYear}`;
        if (cityId) url += `&cityId=${cityId}`;
        if (organizationId) url += `&organizationId=${organizationId}`;
    
        return url;
      },
    
      transformResponse: (response) => {
        const {
          totalCount = 0,
          data: rows = [],
          lastWeekPercentage = 0,
          lastMonthPercentage = 0,
          thisWeekPercentage = 0,
          thisMonthPercentage = 0,
          weekComparison = "-",
          monthComparison = "-",
        } = response?.data || {};
    
        return {
          rows,
          totalCount,
          lastWeekPercentage,
          lastMonthPercentage,
          thisWeekPercentage,
          thisMonthPercentage,
          weekComparison,
          monthComparison,
        };
      },
    }),
    getExportJobs: builder.query({
      query: ({
        financialYear ="2025-2026",
        cityId,
        organizationId,
        dateRange,

      } = {}) => {
        console.log(financialYear ="2025-2026",
        cityId,
        organizationId,
        dateRange,"checking")
        let url = `/export/reExport?financialYear=${financialYear}`;
    
        if (cityId) url += `&cityId=${cityId}`;
        if (organizationId) url += `&organizationId=${organizationId}`;
        if(dateRange) url +=`&from=${dateRange.from}&to=${dateRange.to}`
        return url;
      },
      transformResponse: (response) => {
        return response?.data ?? [];
      },
    }),


    toggleLock: builder.mutation({
      query: ({ exporterMasterId, requestId }) => {

        return {
          url: `/export/lock/${exporterMasterId}`,
          method: "PUT",
          headers: {
            "X-Request-Id": requestId || `${Date.now()}`,
          },
        };
      },
      invalidatesTags: ["Dashboard"],
    }),
    
    deleteJob: builder.mutation({
      query: ({ exporterMasterId, requestId, reason }) => {
   
    
        return {
          url: `/export/${exporterMasterId}`,
          method: "DELETE",
          headers: {
            "X-Request-Id": requestId || `${Date.now()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ reason }),
        };
      },
      invalidatesTags: ["Dashboard"],
    }),
    
  }),
});

export const {
  useLazyGetExportJobsQuery,
  useGetDashboardQuery,
  useGetExportJobsQuery,
  useToggleLockMutation,
  useDeleteJobMutation,
} = dashboardApi;
